import React from "react";
import styled from "styled-components";
import { ConnectWallet } from "../../shared/icons";

const StyledConnectButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  background-color: #ff9d59 !important;
  padding: 12px 20px;
  color: #fff;
  border-radius: 50px;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

interface ConnectButtonProps {
  onClick: () => void;
  label?: string;
}

const ConnectButton: React.FC<ConnectButtonProps> = ({
  onClick,
  label = "Connect",
}) => {
  return (
    <StyledConnectButton onClick={onClick}>
      {label}
      <span>
        <ConnectWallet />
      </span>
    </StyledConnectButton>
  );
};

export default ConnectButton;
